import { useFormAddProductsToCart } from '@graphcommerce/magento-product'
import { useWatch } from '@graphcommerce/react-hook-form'
import { Trans } from '@lingui/react'
import {
  AddProductsToCartButtonWithModal,
  AddProductsToCartModalProps,
} from './AddProductsToCartButtonWithModal'
import { useGetCurrentProductQtyFromCart } from './useGetCurrentProductQtyFromCart'

type AddProductsToCartButtonWithModalWrapperProps = Omit<AddProductsToCartModalProps, 'label'> & {
  index?: number
}

export function AddProductsToCartButtonWithModalWrapper(
  props: AddProductsToCartButtonWithModalWrapperProps,
) {
  const { infoForm, callADruggist, product, index = 0 } = props
  const { stock_status, sku, has_catalog_rule, has_cart_rule } = product
  const maxQty = 10
  const { control, loading: addToCartLoading } = useFormAddProductsToCart()
  const currentQty = useWatch({ control, name: `cartItems.${index}.quantity` })
  const { cartItemQty = 0, loading: qtyLoading } = useGetCurrentProductQtyFromCart({
    sku,
  })
  const remainingQty = cartItemQty ? maxQty - cartItemQty : maxQty
  const isPromotionProduct = Boolean(has_cart_rule || has_catalog_rule)

  const disableCart = Boolean(
    (isPromotionProduct && (cartItemQty + currentQty > maxQty || remainingQty === 0)) ||
      addToCartLoading ||
      qtyLoading,
  )

  return (
    <AddProductsToCartButtonWithModal
      fullWidth
      product={product}
      infoForm={infoForm}
      callADruggist={callADruggist}
      disabled={disableCart}
      label={
        stock_status === 'OUT_OF_STOCK' ? <Trans id='Out of stock' /> : <Trans id='Add to Cart' />
      }
      sx={(theme) => ({
        gridArea: 'addToCart',
        display: 'flex',
        justifySelf: 'flex-end',
        width: '200px',
        py: { xs: theme.spacings.xs, md: '12px' },
        px: theme.spacings.xs,
        borderTopRightRadius: 0,
        borderBottomRightRadius: 0,
        lineHeight: 'normal',
        fontSize: { xs: theme.typography.subtitle1, md: theme.typography.subtitle2 },
        fontWeight: '600',
        transition: 'color .2s ease, background-color .2s ease',
        mt: 1,

        '&:hover': {
          backgroundColor: `${theme.palette.primary.contrastText} !important`,
          color: theme.palette.primary.main,
          boxShadow: 'none',
        },
        [theme.breakpoints.down('md')]: {
          left: theme.spacings.md,
          position: 'relative',
        },
        '&.Mui-disabled': {
          opacity: 0.25,
          color: theme.palette.primary.contrastText,
          backgroundColor: theme.palette.primary.main,
        },
      })}
    />
  )
}
